import * as yup from 'yup'
const schema = yup.object().shape({
    email: yup.string()
        .email(' Please provide a valid email address')
        .required(' Whoops! It looks like you forgot to add your email ')
})

export default schema